var _style, _ellipse, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGateway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PSE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.25 187.833",
    style: {
      enableBackground: "new 0 0 188.25 187.833"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#Circle_2_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FDB718;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Circle_2_",
    cx: 96.0109,
    cy: 357.5831,
    r: 93.1552,
    fx: 45.8266,
    fy: 353.8991,
    gradientTransform: "matrix(1 0 0 1 0 -264)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3155,
    style: {
      stopColor: "#2D5CA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5312,
    style: {
      stopColor: "#285496"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7289,
    style: {
      stopColor: "#1F4272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D2D4D"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Circle_1_",
    className: "st0",
    cx: 94.345,
    cy: 93.917,
    rx: 93.157,
    ry: 93.153
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PSE_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.47,71H97.417c-0.099,0-0.198-0.014-0.295,0.006C93.613,71.767,87,75.354,87.034,83.188 C86.852,86.202,88.172,91,94.475,93c0.019,0,15.72,0,15.72,0c0.696,0,4.989,0.982,4.704,8.47c-0.288,7.549-6.724,8.53-7.65,9.53 H82.891c-0.768,0-1.391,0.732-1.391,1.5s0.623,1.5,1.391,1.5h24.492c0.079,0,0.157-0.366,0.235-0.38 c3.344-0.572,9.749-4.002,10.062-12.207c0.404-10.611-7.273-11.281-7.351-11.286c0.011-0.003-15.516-0.045-15.516-0.045 c-5.301-0.97-5.015-6.598-4.999-6.843c0.002-0.034,0.003,0.054,0.003,0.02C89.76,76.152,96.514,74,97.581,74h21.89 c0.768,0,1.391-0.732,1.391-1.5C120.861,71.732,120.238,71,119.47,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.047,70.843C152.92,70.807,152.788,71,152.656,71h-16.478c-7.459,0-10.828,8.637-10.967,9.014 c-0.023,0.061-0.04,0.016-0.055,0.08c-0.171,0.773-4.187,18.937-4.052,24.934c0.129,5.642,5.875,7.693,8.895,8.016 c0.05,0.006,0.1-0.043,0.151-0.043h22.908c0.778,0,1.41-0.722,1.41-1.5s-0.631-1.5-1.41-1.5h-22.822 c-0.717,0-6.212-0.838-6.311-5.205c-0.053-2.344,0.614-6.83,1.418-11.362l31.881-0.238c0.68-0.005,1.26-0.482,1.377-1.153 c0.062-0.35,1.494-8.503,1.494-13.392C160.094,72.834,153.335,70.927,153.047,70.843z M156.014,90.414l-30.154,0.252 c0.926-4.913,1.868-8.94,2.027-9.663c0.322-0.805,3.088-7.004,8.291-7.004h16.255c0.88,0,4.842,1.556,4.842,4.853 C157.275,82.457,156.409,87.958,156.014,90.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.84,79.444C83.667,73.817,76.56,71,75.23,71c-0.002,0-0.004,0-0.004,0c-5.739,0-14.433,0.197-15.34,0.166 c-0.121-0.013-0.246,0.067-0.372,0.086c-3.554,0.566-8.38,5.143-9.93,9.377l0.024,0.029c-0.155,0.472-0.291,1.2-0.498,2.294 c-0.251,1.323-0.602,3.218-1.021,5.485c-0.836,4.53-1.939,10.573-3.039,16.613c-2.2,12.079-4.384,24.158-4.384,24.158 c-0.135,0.745,0.36,1.459,1.105,1.594c0.082,0.015,0.164,0.023,0.245,0.023c0.65,0,1.228-0.464,1.347-1.128 c0.924-5.106,2.439-13.468,3.957-21.805c3.579,4.515,8.031,4.989,8.254,5.01c0.055,0.006,0.11,0.01,0.167,0.005l14.091-0.403 c0.121-0.003,0.239-0.022,0.354-0.057c6.685-2.005,8.695-8.903,8.778-9.196c0.013-0.049,0.025-0.099,0.033-0.15l3.825-23.429 C82.832,79.622,82.833,79.494,82.84,79.444z M80.104,79.391l-3.797,23.176c-0.198,0.621-1.944,5.659-6.739,7.201l-13.8,0.394 c-0.636-0.089-4.942-0.881-7.732-6.195c2.032-11.153,3.898-21.318,4.139-22.397c1.279-3.436,5.416-7.128,7.737-7.525 c0.526,0.032,1.245,0.033,2.24,0.035c1.453,0.002,3.394,0.001,5.333-0.003c3.213-0.005,6.424-0.016,7.429-0.02 C76.542,74.045,80.5,76.808,80.104,79.391z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Figures"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 19.366,
    cy: 66.019,
    rx: 3.923,
    ry: 4.185
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.405,52.808c0-1.839-1.119-3.384-2.665-3.945c-1.306,2.363-2.513,4.789-3.614,7.272 c0.658,0.531,1.468,0.858,2.356,0.858C13.649,56.993,15.405,55.119,15.405,52.808z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.484,66.019c0-1.135-0.427-2.162-1.115-2.916c-0.806,2.304-1.525,4.648-2.151,7.03 C6.07,69.798,7.484,68.09,7.484,66.019z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 19.913,
    cy: 117.005,
    rx: 3.923,
    ry: 4.185
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.055,117.005c0-1.745-1.215-3.174-2.79-3.412c0.446,2.067,0.957,4.11,1.538,6.124 C5.56,119.083,6.055,118.11,6.055,117.005z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.387,130.652c0-2.311-1.756-4.185-3.923-4.185c-1.547,0-2.871,0.963-3.51,2.35 c0.812,2.004,1.69,3.974,2.635,5.906c0.282,0.069,0.573,0.113,0.875,0.113C13.63,134.837,15.387,132.963,15.387,130.652z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.046,104h-7.867c-0.51-1-1.971-2.721-3.715-2.721c-2.167,0-3.923,1.964-3.923,4.275 c0,2.311,1.756,4.266,3.923,4.266c1.744,0,3.205-0.821,3.715-2.821h6.44h2.217h0.188l8.251-15H44v-2H23.14l-8.575-15h-0.598H11.76 H3.076c-0.204,0.994-0.388,1.995-0.561,3h10.803l7.018,12H1.25c-0.027,0.665-0.049,1.331-0.062,2H28.87L22.046,104z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ach_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.233,58.499h4.206c0,0,1.233,0.363,1.015,1.813l-0.798,5.584h-4.424c0,0-1.958-0.725-0.943-2.828 c0,0,0.925-1.124,1.741-1.124l4.052,0.136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.997,58.499H62.79c0,0-1.45,0.725-1.813,2.611c0,0-0.979,2.756,0.181,4.786l0.49,0.109H65.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "69.426,55.108 68.815,58.499 67.45,66.077  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.561,59.91c0,0,0.503-0.995,1.373-1.412c0,0,3.173-0.308,3.735,0.49c0,0,0.635,0.308,0.598,1.215 l-0.979,5.693"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateway);
export default __webpack_public_path__ + "static/media/gateway.103b7771ddc0f949a3daa4f8e5c2c39d.svg";
export { ForwardRef as ReactComponent };